let storageProbePromise = null;

function bucketHint(bucketName) {
  const bucket = String(bucketName || "").trim();
  return bucket ? ` (bucket: ${bucket})` : "";
}

export function formatUploadError(error, bucketName = "") {
  const code = String(error?.code || "").toLowerCase();
  const message = String(error?.message || "Upload failed").trim();
  const lower = message.toLowerCase();

  if (
    code === "storage/bucket-not-found" ||
    code === "storage/no-default-bucket" ||
    code === "storage/project-not-found" ||
    lower.includes("storage has not been set up") ||
    lower.includes("bucket not found")
  ) {
    return (
      "Firebase Storage is not configured for this project. " +
      "Open Firebase Console -> Storage -> Get Started, then retry." +
      bucketHint(bucketName)
    );
  }

  if (code === "storage/unauthenticated" || code === "storage/unauthorized") {
    return "You do not have permission to upload this file. Please login again and retry.";
  }
  if (code === "storage/retry-limit-exceeded") {
    return "Upload timed out due to network retries. Please check internet and try again.";
  }
  if (code === "storage/quota-exceeded") {
    return "Storage quota exceeded. Contact admin to increase Firebase Storage quota.";
  }
  if (code === "storage/canceled") {
    return "Upload was canceled.";
  }
  if (code === "storage/invalid-checksum") {
    return "Upload checksum failed. Please retry with the same file.";
  }
  return message;
}

export async function assertStorageReady(bucketName = "") {
  const bucket = String(bucketName || "").trim();
  if (!bucket) {
    throw new Error(
      "Storage bucket is missing in app config. Set storageBucket in Firebase config first.",
    );
  }

  if (!storageProbePromise) {
    const url = `https://firebasestorage.googleapis.com/v0/b/${encodeURIComponent(bucket)}/o?maxResults=1`;
    storageProbePromise = fetch(url, { method: "GET" })
      .then(async (res) => {
        // 404 means bucket/project storage is not initialized.
        if (res.status === 404) {
          throw new Error(
            "Firebase Storage is not configured for this project. " +
            "Open Firebase Console -> Storage -> Get Started.",
          );
        }
        // 200/401/403 all mean bucket exists.
        return true;
      })
      .catch((error) => {
        storageProbePromise = null;
        throw error;
      });
  }

  return storageProbePromise;
}
